import type { AttributeKey } from '~/constants/config/attribution-list';

/**
 * Ordered list of enriched fields the preview table may render.
 * Exactly mirrors `attributes` from the attribution list, minus `title` (fixed sticky column).
 * Only fields present (non-null) in the live API response are shown as columns.
 */
export const ENRICHED_FIELD_KEYS: readonly Exclude<AttributeKey, 'title'>[] = [
  'structuredTitle',
  'shortTitle',
  'description',
  'structuredDescription',
  'productHighlight',
  'productDetail',
  'productType',
  'color',
  'material',
  'pattern',
  'multipack',
  'isBundle',
  'googleProductCategory',
  'productLength',
  'productWidth',
  'productHeight',
  'productWeight',
  'questionAndAnswer',
  'documentLink',
  'relatedProduct',
  'itemGroupTitle',
  'variantOption',
  'popularityRank',
];

/** Human-readable column headers keyed by attribution attribute name. */
export const ENRICHED_FIELD_LABELS: Record<Exclude<AttributeKey, 'title'>, string> = {
  structuredTitle: 'Structured Title',
  shortTitle: 'Short Title',
  description: 'Description',
  structuredDescription: 'Structured Description',
  productHighlight: 'Product Highlights',
  productDetail: 'Product Details',
  productType: 'Product Type',
  color: 'Color',
  material: 'Material',
  pattern: 'Pattern',
  multipack: 'Multipack',
  isBundle: 'Bundle',
  googleProductCategory: 'Google Product Category',
  productLength: 'Length',
  productWidth: 'Width',
  productHeight: 'Height',
  productWeight: 'Weight',
  questionAndAnswer: 'Questions & Answers',
  documentLink: 'Document Link',
  relatedProduct: 'Related Products',
  itemGroupTitle: 'Item Group Title',
  variantOption: 'Variant Options',
  popularityRank: 'Popularity Rank',
};
